import React from "react";
const EstimateTableHeader: React.FC<{}> = () => {
	return (
		<div className="w-[100%] h-12 px-6 bg-gray-50 border-t border-b border-[#eaecf0] justify-between items-center inline-flex">
			<div className="self-stretch justify-start items-center flex">
				<div className="w-[52px] self-stretch justify-start items-center gap-1 flex">
					<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 justify-center items-center flex">
						<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
					</div>
					<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">
						No.
					</div>
				</div>
				<div className="w-[300px] self-stretch pr-4 justify-start items-center gap-1 flex">
					<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
						<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
					</div>
					<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">
						Line Item
					</div>
				</div>
				<div className="w-40 self-stretch justify-start items-center gap-1 flex">
					<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
						<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
					</div>
					<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight  ">
						Documented Quantity
					</div>
				</div>
				{/* <div className="w-24 self-stretch justify-start items-center gap-1 flex">
				<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
					<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
				</div>
				<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">QTY 2</div>
			</div> */}
				<div className="w-40 self-stretch justify-start items-center gap-1 flex">
					<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
						<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
					</div>
					<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">
						Final Quantity
					</div>
				</div>
				<div className="w-40 self-stretch justify-start items-center gap-1 flex">
					<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
						<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
					</div>
					<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">
						Confidence
					</div>
				</div>
				{/* <div className="w-40 self-stretch justify-start items-center gap-1 flex">
				<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
					<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
				</div>
				<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">Remove</div>
			</div>
			<div className="w-40 self-stretch justify-start items-center gap-1 flex">
				<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
					<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
				</div>
				<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">Replace</div>
			</div>
			<div className="w-[89px] self-stretch justify-start items-center gap-1 flex">
				<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
					<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
				</div>
				<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">Tax ($)</div>
			</div>
			<div className="w-[88px] self-stretch justify-start items-center gap-1 flex">
				<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
					<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
				</div>
				<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">O&P ($)</div>
			</div>
			<div className="w-[89px] self-stretch justify-start items-center gap-1 flex">
				<div className="w-4 h-4 pl-[5.14px] pr-[4.86px] pt-[3px] pb-1 opacity-0 justify-center items-center flex">
					<div className="w-1.5 h-[9px] relative flex-col justify-start items-start flex" />
				</div>
				<div className="grow shrink basis-0 text-[#0f1728] text-sm font-semibold font-['Hanken Grotesk'] leading-tight">Total ($)</div>
			</div> */}
			</div>
			<div className="h-10 opacity-0 justify-start items-start gap-4 flex">
				<div className="p-2.5 bg-white rounded-lg shadow border border-[#cfd4dc] justify-center items-center gap-2 flex">
					<div className="w-5 h-5 px-[2.50px] pt-[2.40px] pb-[3.33px] justify-center items-center flex" />
				</div>
				<div className="p-2.5 bg-[#d92c20] rounded-lg shadow border border-[#d92c20] justify-center items-center gap-2 flex">
					<div className="w-5 h-5 px-[2.50px] py-[1.67px] justify-center items-center flex" />
				</div>
			</div>
		</div>
	);
};

export default EstimateTableHeader;
